exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-black {\r\n       color: white;\r\n       background-color: #304047;\r\n       border-color: #304047;\r\n   }\r\n\r\n       .btn-outline-black:hover {\r\n           color: white;\r\n           background-color: black;\r\n       }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/button/button.css
// module id = 1094
// module chunks = 322